/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import { render } from 'react-dom';

import '@fontsource/atkinson-hyperlegible-next/400.css';
import '@fontsource/atkinson-hyperlegible-next/500.css';
import '@fontsource/atkinson-hyperlegible-next/600.css';
import '@fontsource/atkinson-hyperlegible-next/700.css';
import '@fontsource/atkinson-hyperlegible-mono/400.css';
import '@fontsource/atkinson-hyperlegible-mono/600.css';

import App from './components/App';
import './style/global.css';

render(
  <App />,
  document.getElementById('root')
);
